"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _rootReducer = _interopRequireDefault(require("./reducers/rootReducer"));

var _epics = _interopRequireDefault(require("./epics"));

var _AsyncQuotasContainer = _interopRequireDefault(require("./containers/AsyncQuotasContainer"));

var _scopeChecks = require("settings-ui-lib/utils/scopeChecks");

var _Constants = require("./Constants");

var QuotasModule = {
  route: _UrlPathParams.QUOTAS,
  routes: _react.default.createElement(_reactRouter.Route, {
    path: _UrlPathParams.QUOTAS,
    component: _AsyncQuotasContainer.default
  }, _react.default.createElement(_reactRouter.Route, {
    path: _Constants.QUOTES_ROUTE
  })),
  reducer: _rootReducer.default,
  rootEpic: _epics.default,
  shouldModuleRender: (0, _scopeChecks.matchesAllScopes)(['sales-settings-access'])
};
var _default = QuotasModule;
exports.default = _default;
module.exports = exports.default;